import { defineStore } from "pinia";
import { API, login } from "@/services/auth";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: localStorage.getItem("token") || "",
    user: JSON.parse(localStorage.getItem("user")) || null,
    isLoggedIn: !!localStorage.getItem("token"),
    loading: false,
    error: null,
  }),
  actions: {
    async loginUser(credentials) {
      this.loading = true;
      this.error = null;
      try {
        const response = await login(credentials);
        this.token = response.data.access_token; // فرضی، اسم فیلد توکن رو با API خودت هماهنگ کن
        localStorage.setItem("token", this.token);
        this.user = response.data.user;
        localStorage.setItem("user", JSON.stringify(this.user));
        // تنظیم توکن در هدر axios برای درخواست‌های بعدی
        this.setAuthHeader(this.token);

        this.isLoggedIn = true;
      } catch (err) {
        this.error = err.response?.data?.message || "خطای ورود";
        this.logout();
      } finally {
        this.loading = false;
      }
    },
    logout() {
      this.token = "";
      this.user = null;
      this.isLoggedIn = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.setAuthHeader(null);
    },
    setAuthHeader(token) {
      if (token) {
        API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      } else {
        delete API.defaults.headers.common["Authorization"];
      }
    },
  },
});
